import {
  extractAssetOwnerPayoutFromPayload,
} from './assetOwnerPayoutBank';

function pickString(...values: unknown[]): string | null {
  for (const v of values) {
    if (typeof v === 'string' && v.trim()) {
      return v.trim();
    }
  }
  return null;
}

export type ProfilePayoutDisplaySummary = {
  payoutCountry: 'IL' | 'US';
  accountHolderName: string | null;
  bankNumber: string | null;
  branchNumber: string | null;
  accountNumber: string | null;
  routingNumber: string | null;
  accountType: 'checking' | 'savings' | '' | null;
  transferDay: number | null;
};

export function extractProfileBusinessName(record: Record<string, unknown> | null): string | null {
  return record ? pickString(record.business_name, record.businessName) : null;
}

export function extractProfileBusinessId(record: Record<string, unknown> | null): string | null {
  return record ? pickString(record.business_id, record.businessId) : null;
}

export function extractProfileSecondaryPhone(record: Record<string, unknown> | null): string | null {
  return record
    ? pickString(record.phone_number_2, record.phoneNumber2, record.secondary_phone_number)
    : null;
}

export function extractProfilePayoutSummary(
  record: Record<string, unknown> | null,
): ProfilePayoutDisplaySummary | null {
  if (!record) {
    return null;
  }
  const fields = extractAssetOwnerPayoutFromPayload(record);
  const payoutConfigured =
    record.payout_configured === true || record.payoutConfigured === true;
  const hasBankData =
    payoutConfigured ||
    Boolean(fields.account_holder_name.trim()) ||
    Boolean(fields.account_number) ||
    Boolean(fields.bank_number) ||
    Boolean(fields.branch_number) ||
    Boolean(fields.routing_number) ||
    fields.payout_transfer_day !== '';

  if (!hasBankData) {
    return null;
  }

  return {
    payoutCountry: fields.payout_country,
    accountHolderName: fields.account_holder_name.trim() || null,
    bankNumber: fields.bank_number || null,
    branchNumber: fields.branch_number || null,
    accountNumber: fields.account_number || null,
    routingNumber: fields.routing_number || null,
    accountType: fields.account_type || null,
    transferDay: fields.payout_transfer_day === '' ? null : fields.payout_transfer_day,
  };
}

export function payoutDisplaySummaryFromWirePayload(
  payload: Record<string, unknown>,
): ProfilePayoutDisplaySummary | null {
  return extractProfilePayoutSummary(payload);
}
